import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, App, Events } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { NotifipopupPage } from '../notifipopup/notifipopup';
import { NotificationPage } from '../notification/notification';
import { NotifimodalPage } from '../notifimodal/notifimodal';
import { CashroomPage } from '../cashroom/cashroom';
import { BonusroomPage } from '../bonusroom/bonusroom';
import { BonuslistPage } from '../bonuslist/bonuslist';
import { MygroupPage } from '../mygroup/mygroup';

declare var Highcharts : any;

/**
 * Generated class for the WalletPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-wallet',
    templateUrl: 'wallet.html',
})
export class WalletPage {

	rootPage: any;
	// user_id: string;
	// user_name: string;
	email: string;
	office_email: string;
	invite: string;
	company: string;
	
	loginId: string;
    api_key: string;
    version: string;
    mode: string;

    coin_unit: string;
    coin_name: string;
    unit: string;
    cash_room_unit: string;
    bonus_room_unit: string;

    chucheon_url: string;
    chucheon_base_url: string;
    test_chucheon_base_url: string;
    // half_value: any;
    // max_percent: string;
    // min_percent: string;
    // cha_percent: string;
    // max: any = [];
    // min: any = [];
    // cha: any = [];
    
    balance: any = [];
    rank: any = [];
    level: any = [];
    daily: any = [];
    rate: any = [];

    // chucheon: any = [];

    // balance_point_parts01: string;
    // balance_point_parts02: string;

    // staking_value: string;
    // staking_interest: string;
    // staking_list: any = [];

    // bonus_name: any = [];
    // bonus_value_one_coin: any = [];
    // bonus_value_two_coin: any = [];
    // bonus_list_one: any = [];
    // bonus_list_two: any = [];

    // withdraw_list: any = [];

    // ticker: any = [];

	notice: any = [];

    badges: string;
    
    texts: any = [];
    language: string;

    opened: boolean = false;
  
	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public modalCtrl: ModalController,
		public alertCtrl: AlertController,
		private http: HttpService,
		public app: App,
		public events: Events
	) {
		this.coin_unit = "";

    }
    
    ionViewWillEnter() {

		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
        localStorage.setItem("pageName", "wallet");
        this.language = localStorage.getItem("language");
        this.email = localStorage.getItem("email");
        this.version = localStorage.getItem("version");
        this.invite = localStorage.getItem("invite");
        this.office_email = localStorage.getItem("office_email");
        this.company = localStorage.getItem("company");
        this.mode = localStorage.getItem("mode");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.coin_name = localStorage.getItem("coin_name");
        this.unit = localStorage.getItem("unit");
		this.cash_room_unit = localStorage.getItem("cash_room_unit");
		this.bonus_room_unit = localStorage.getItem("bonus_room_unit");
        this.chucheon_base_url = localStorage.getItem("chucheon_base_url");
        this.test_chucheon_base_url = localStorage.getItem("test_chucheon_base_url");


        this._get_texts();
        // this._bonus_progress();
        if (this.mode == "main" ) {
            this.chucheon_url = this.chucheon_base_url + this.api_key;
        } else {
            this.chucheon_url = this.test_chucheon_base_url + this.api_key;
        }
        // this.chucheon_url = "http://btcxclub.ddsapp.net/tree/huwon/" + this.api_key

        this._init().then((res: any) => {
            this._chart_rate(res);
            // if (res != undefined) {

            //     if (res.chart != undefined) {   
            //         this._chart_rate(res.chart);
            //         // this.today_rate = res.rate_value;
            //     }
            // }
		});
        
		// this._init();

		// this._jquery();
		// this.interval();
		
		// this.events.subscribe('init', init => {
		// 	this._init();
		// })
	}

	ionViewDidLoad() {
		this._once();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).wallet;
	}
	
	_once() {
		if (this.api_key == '' || this.api_key == undefined || this.api_key == null) {
			this.api_key = localStorage.getItem("api_key");
		}
		this.loginId = localStorage.getItem("loginId");
		this.language = localStorage.getItem("language");
		this.version = localStorage.getItem("version");

		let url = "info/notice/index/after";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.badges = res.badges;
				if (res.list == undefined) {
					return;
				} else {
					let modal = this.modalCtrl.create(NotifipopupPage, {list: res.list});
					modal.present();
					modal.onDidDismiss( idx => {
						if(idx == "" || idx == undefined || idx == null) {
							return;
						} else {              
							let url = "info/notice/index/save";
							let body = JSON.stringify({ 
								api: this.api_key,
								language: this.language,
								version: this.version,
								idx: idx
							});
							this.http.post(url, body).then((res: any) => {
								if(res.result=="OK"){
									this._once();
                                    if (this.badges != undefined) this._init();

								} else {
									let alert = this.alertCtrl.create({
										message: res.message,
										buttons: ['OK']
									});
									alert.present();
								}
								
							},(err)=>{	
								//// HTTP 에러인 경우
								let alert = this.alertCtrl.create({
									message: this.texts.alertM_err,
									buttons: ['OK']
								});
								alert.present();
							
							});
						}
					});
				}
				
				
			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}

	_init() {
        return new Promise((resolve,reject)=>{
            let url = "config/dashboard";
            let body = JSON.stringify({ 
                api: this.api_key,
                language: this.language,
                version: this.version
            });
            this.http.post(url, body).then((res: any) => {
                if(res.result=="OK"){
                    this.balance = res.balance;
                    this.rank = res.rank;
                    this.level = res.level;
                    this.daily = res.daily;
                    this.rate = res.rate;
                    // this.bonus = res.bonus;
                    // this.balance_point = this.balance.point;    
                    // var parts = balance_point.toString().split(".");
                    // this.balance_point_parts01 = parts[0];
                    // this.balance_point_parts02 = parts[1];

                    if (res.notice != undefined) {   
                        this.notice = res.notice;
                    }
                    this.badges = res.badges;
                    // if (res.bonus != undefined) {   
                    //     this.bonus = res.bonus;
                    // }

                    // if (res.chucheon != undefined) {   
                    //     this.chucheon = res.chucheon;
                    // }

                    resolve(res.chart);

                    // this.notice = res.notice;

                } else if(res.result ==="LOGOUT"){
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                    localStorage.removeItem("loginId");
                    localStorage.removeItem("api_key");
                    this.app.getRootNav().setRoot(LoginPage);
                
                } else {
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                }
            },(err)=>{	
                //// HTTP 에러인 경우
                let alert = this.alertCtrl.create({
                    message: this.texts.alertM_err,
                    buttons: ['OK']
                });
                alert.present();
            
            });
        });
	}

    // _bonus_progress() {
    //     this.max = [];
    //     this.min = [];
    //     this.cha = [];

    //     let url = "bonus/progress";
	// 	let body = JSON.stringify({ 
	// 		api: this.api_key,
    //         language: this.language,
    //         version: this.version
	// 	});
	// 	this.http.post(url, body).then((res: any) => {
	// 		if(res.result=="OK"){ 
    //             this.max = res.max;
	// 			this.min = res.min;
	// 			this.cha = res.cha;

    //             let max_value: any;
    //             let half_value: any;
    //             max_value = res.max.value.replace(/[^0-9]/g, "");
                
    //             half_value = max_value / 2;
    //             half_value = String(half_value);

    //             this.half_value = half_value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                
                
	// 		} else if(res.result ==="LOGOUT"){
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
			
	// 		} else {
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
	// 		}
	// 	},(err)=>{	
	// 		//// HTTP 에러인 경우
	// 		let alert = this.alertCtrl.create({
	// 			message: this.texts.alertM_err,
	// 			buttons: ['OK']
	// 		});
	// 		alert.present();
		
	// 	});
    // }

    _btn_event(event) {
        if (event == 'btn01' || event == 'btn02') {
            this.navCtrl.push(BonuslistPage, {target: event});
        }

        if (event == 'cash') {
            this.navCtrl.push(CashroomPage);
        }

        if (event == 'bonus') {
            this.navCtrl.push(BonusroomPage);
        }

        if (event == 'web_chucheon') {
            this.navCtrl.push(MygroupPage);
        }

        // if (event == 'deposit') {
        //     this.navCtrl.push(ApplylistPage);
        // }

        // if (event == 'withdrawal') {
        //     this.navCtrl.push(WithdrawalcoinlistPage);
        // }

        // if (event == 'setting') {
        //     this.navCtrl.push(MypagePage);
        // }
        
        // if (event == 'chucheon') {
        //     this.navCtrl.push(MygroupPage);
        // }

        if (event == 'ready') {
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_ready,
                buttons: ['OK']
            });
            alert.present();
        }
    }

    // _line_event(line) {
    //     this.navCtrl.push(HuwonPage, {line: line});
    // }

    // _deposit_event(item) {
    //     this.navCtrl.push(CountdownPage, {item: item});
    // }
	
	_notifi(idx) {
        if (idx !== ''){
            this.navCtrl.push(NotifimodalPage, {idx: idx});
        } else {
            this.navCtrl.push(NotificationPage);
        }
	}

    // toggleFunc() {
    //     this.opened = !this.opened;

    //     this.max_percent = "0";
    //     this.min_percent = "0";
    //     this.cha_percent = "0";

    //     setTimeout(() =>{
    //         this.max_percent = this.max.percent + "%";
    //         this.min_percent = this.min.percent + "%";
    //         this.cha_percent = this.cha.percent + "%";
    //     }, 500);
    // }

    _chart_rate(chart) {
        Highcharts.setOptions({
        	lang:{
            	rangeSelectorZoom: '',
                thousandsSep: ','
            },
            colors: ['rgb(255, 157, 0)','rgb(174, 245, 81)'],
            global: {
                useUTC: false
            }
        });

        Highcharts.stockChart('chart_rate', {
            
            chart: {
                height: 130,
                type: 'area'
            },
            rangeSelector: {
                enabled: false,
            },
            title: {
                text: null
            },
            navigator: {
                enabled: false,
            },
            exporting: {
                enabled: false
            },
            scrollbar: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            yAxis: {
                opposite: true,
                
                crosshair: {
                    width: 1,
                    // color: '#111'
                },
                labels: {
                    enabled: false
                }

                // labels: {
                //     format: '{value:,.0f}',
                //     style: {
                //         color: '#111',
                //         fontWeight: 'bold'
                //     }
                // }
            },
            xAxis: {
                labels: {
                    enabled: false
                }
                
                // labels: {
                //     format: '{value:%d}',
                //     style: {
                //         color: '#111',
                //         fontWeight: 'bold'
                //     }
                // },
            },
            tooltip: {
                format: '{value:,.0f}',
                dateTimeLabelFormats: '{value:%Y-%m-%d}',
                followPointer: false,
                shared: true,
                style: {
                    // fontSize: '11px',
                    zIndex: 999
                }
            },
            plotOptions: {
                series: {
                    lineWidth: 3,
                    marker: {
                        enabled: true,
                        radius: 3
                    },
                }
            },
            series: [{
                // showInLegend: false,
                name: 'Referral',
                data: chart.bonus,
                fillColor: {
                    linearGradient: [0, 0, 0, 300],
                    stops: [
                        // [0, 'rgba(255,255,255,0)'],
                        // [1, 'rgba(255,255,255,0)']
                        [0, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0.2).get('rgba')],
                        [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                    ]
                },
                // shadow: true
            }, {
                // showInLegend: false,
                name: 'Sponsorship',
                data: chart.cash,
                fillColor: {
                    linearGradient: [0, 0, 0, 300],
                    stops: [
                        // [0, 'rgba(255,255,255,0)'],
                        // [1, 'rgba(255,255,255,0)']
                        // [0, Highcharts.getOptions().colors[0]],
                        [0, Highcharts.color(Highcharts.getOptions().colors[1]).setOpacity(0.2).get('rgba')],
                        [1, Highcharts.color(Highcharts.getOptions().colors[1]).setOpacity(0).get('rgba')]
                    ]
                },
                // shadow: true
            }]
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/wallet/wallet.ts